<template lang="pug">
#tabela-dados-financeiros-pj
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    div
        BaseInfoBlock(
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.dadosFinanceiros.classificacaoTamanhoEmpresa")]',
            :valores-info-block='[dados["empresa-porte"]?.empresaPorte]'
        )
        el-divider
        BaseInfoBlock(
            v-if='dados.faturamentoEstimado',
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.dadosFinanceiros.faixaFaturamentoAnualEmpresa")]',
            :valores-info-block='[dados.faturamentoEstimado.faixaIndividual]'
        )
        el-divider(v-if='dados.faturamentoEstimado')
        BaseInfoBlock(
            v-if='dados.faturamentoEstimado',
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.dadosFinanceiros.faixaFaturamentoAnualEmpresasGrupo")]',
            :valores-info-block='[dados.faturamentoEstimado.faixaGrupo]'
        )
        el-divider(v-if='dados.faturamentoEstimado')
        BaseInfoBlock(
            v-if='dados.potencialConsumo',
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.dadosFinanceiros.valorDeclaradoCapitalSocialEmpresa")]',
            :valores-info-block='[formatValorBRL(dados.potencialConsumo.valorCapitalSocial)]'
        )
        el-divider(v-if='dados.totalFuncionarios')
        BaseInfoBlock(
            v-if='dados.totalFuncionarios',
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.dadosFinanceiros.quantidadeFuncionariosRegistradosClt")]',
            :valores-info-block='[dados.totalFuncionarios.quantidade]'
        )
        BaseInfoBlock(
            v-else,
            :titulos-info-block='[$t("mensagens.preAnaliseCredito.dadosFinanceiros.quantidadeFuncionariosRegistradosClt")]',
            :valores-info-block='["--"]'
        )
    el-alert(
        v-if='!dados',
        :title='$t("mensagens.preAnaliseCredito.dadosFinanceiros.naoHaRegistroParaInfoProfissionais")',
        type='warning',
        :closable='false'
    )
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/modules/pre-analise-credito/components/BaseTableHeader';
import BaseInfoBlock from '@/modules/pre-analise-credito/components/BaseInfoBlock';
import BaseModalVisualizarInfos from '@/modules/pre-analise-credito/components/BaseModalVisualizarInfos';

export default {
    name: 'TabelaDadosFinanceirosPj',

    components: {
        BaseTableHeader,
        BaseInfoBlock,
        BaseModalVisualizarInfos
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data() {
        return {
            activeCollapseItem: ['0']
        };
    },

    methods: {
        formatarCep(row, column, cep, index) {
            return formatters.formatarCEP(cep);
        },
        isEmpty(row, column, data, index) {
            return formatters.isEmpty(data);
        },
        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        formatCpfCnpjTableColumn(row, column, cpfCnpj, index) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        tratarEndereco(endereco) {
            return endereco.municipio + '-' + endereco.uf;
        },
        formatValorBRL(valor) {
            return 'R$ ' + formatters.formatNumber(valor, 2);
        },
        emptyFormatter(row, column, cellValue, index) {
            if (!cellValue) {
                return '- -';
            }
            return cellValue;
        }
    }
};
</script>

<style lang="scss">
#tabela-dados-financeiros-pj {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .table-infos-profissionais {
        height: 100%;
        width: 100%;

        .action-button {
            cursor: pointer;
        }
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }
}
</style>
